(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const translationsModal = {
            "en-GB": {
                'title': 'Next Pop Up Event',
                'prefixCity': 'in',
                'prefixCityPorto': 'in',
                'messageCanFindUs': 'you can find us at',
                'messageSlotsAvaliable': "We still have some slots available.",
                'messageOneSlotAvaliable': "We have one slot available.",
                'messageNoSlotAvaliable': "We don't have any more slots available. But you can still show up.",
                'next': "Next",
                'tomorrow': "Tomorrow",
                'today': "Today",
                'book': "Book Session",
                'continue': "Continue",
                'bookLink': "https://foreverbondstudio.com/en/book/",
                'getAddress': "Get Address",
                'and': "and",
            },
            "pt-PT": {
                'title': 'Próximo Evento Pop Up',
                'prefixCity': 'em',
                'prefixCityPorto': 'no',
                "messageCanFindUs": "estaremos aqui:",
                "messageSlotsAvaliable": "Ainda temos vagas disponíveis.",
                "messageOneSlotAvaliable": "Apenas temos uma vaga disponível.",
                "messageNoSlotAvaliable": "Aparece, que há sempre espaço para mais um!",
                'next': "Na próxima",
                'tomorrow': "Amanhã",
                'today': "Hoje",
                'book': "Agendar Sessão",
                'continue': "Continuar a ver",
                'bookLink': "https://foreverbondstudio.com/agendar/",
                'getAddress': "Obter Morada",
                'and': "e",
            }
        }
        const lang = document.documentElement.lang;

        const hostname = window.location.hostname;
        let prefixRequests = window.location.protocol + '//' + hostname;
        window.location.port && (prefixRequests += ':' + window.location.port);
        if (hostname.includes('foreverbondstudio.local') || hostname.includes('foreverbondstudio.com')) {
            prefixRequests += "/wp-json/eventbooking/v1/"
        } else {
            prefixRequests += "/api/"
        }


        function getAvailabilityMessage(numberSlots) {
            if (numberSlots > 1) {
                return translationsModal[lang].messageSlotsAvaliable;
            } else if (numberSlots === 1) {
                return translationsModal[lang].messageOneSlotAvaliable;
            } else {
                return translationsModal[lang].messageNoSlotAvaliable;
            }
        }

        function formatDateBasedOnLocale(lang, eventDate) {
            const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' };

            function getPortuguesePreposition(date) {
                const dayOfWeek = date.toLocaleDateString('pt-PT', { weekday: 'long' }).toLowerCase();
                // Check for Saturday and Sunday specifically
                if (dayOfWeek === 'sábado' || dayOfWeek === 'domingo') {
                    return "No";
                } else {
                    return "Na";
                }
            }

            if (lang == "en-GB") {
                return `On ${eventDate.toLocaleDateString('en-US', options)}`;
            } else {
                const ptPreposition = getPortuguesePreposition(eventDate);
                return `${ptPreposition} ${eventDate.toLocaleDateString('pt-PT', options)}`;
            }
        }

        function getDateMessage(availability) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Remove time parts

            const eventDate = new Date(availability.date);
            eventDate.setHours(0, 0, 0, 0);

            const tomorrow = new Date(today);
            tomorrow.setDate(tomorrow.getDate() + 1);

            const dayAfterTomorrow = new Date(today);
            dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

            const nextWeek = new Date(today);
            nextWeek.setDate(nextWeek.getDate() + 7);

            if (eventDate.getTime() === today.getTime()) {
                return translationsModal[lang].today;
            } else if (eventDate.getTime() === tomorrow.getTime()) {
                return translationsModal[lang].tomorrow;
            } else if (eventDate.getTime() === dayAfterTomorrow.getTime()) {
                // Checks if the day after tomorrow is within the same week
                if (eventDate.getDay() > today.getDay()) {
                    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                    const daysPT = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
                    if (lang == "pt-PT") {
                        return `${translationsModal[lang].next} ${daysPT[eventDate.getDay()]}`;
                    } else {
                        return `${translationsModal[lang].next} ${days[eventDate.getDay()]}`;
                    }
                }
            }

            // For dates beyond the day after tomorrow or not next specific weekday
            return formatDateBasedOnLocale(lang, eventDate)
        }


        async function fetchCityNextAvailability(city) {
            let headers = {
                'Content-Type': 'application/json'
            };

            // Conditionally add nonce to headers if it exists
            if (typeof apiSettings !== 'undefined') {
                if (apiSettings.nonce) {
                    headers['X-WP-Nonce'] = apiSettings.nonce;
                }
            }
            try {
                const url = `${prefixRequests}nextCityEvent?city=${city}`; // Append city to the URL
                const response = await fetch(url, { method: 'GET', headers: headers });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();

                return data.availabilities;
            } catch (error) {
                console.error('Failed to fetch availability:', error);
            }
        }

        async function displayModal() {
            // Obter o parâmetro 'local' da URL
            const params = new URLSearchParams(window.location.search);
            // Ensure the apiSettings object is available
            if (typeof apiSettings !== 'undefined') {
                var city = apiSettings.city;  // Access the city value passed from PHP
            }

                if (city) {
                const availabilities = await fetchCityNextAvailability(city);
                    if (availabilities && availabilities.length > 0) {
                        // Find the earliest date in the availabilities
                        const earliestDate = new Date(Math.min(...availabilities.map(a => new Date(a.date))));
                        earliestDate.setHours(0, 0, 0, 0); // Normalize the time to ensure whole-day comparison
                        let date = availabilities[0].date
                        let locationName = availabilities[0].locationName
                        let locationCity = availabilities[0].locationCity

                        // Filter events to only include those that match the earliest date
                        const nextDayEvents = availabilities.filter(a => {
                            const eventDate = new Date(a.date);
                            eventDate.setHours(0, 0, 0, 0);
                            return eventDate.getTime() === earliestDate.getTime();
                        });

                        if (nextDayEvents.length > 0) {
                            // Generate the date message using the first event (since all are the same day)
                            const dateMessage = getDateMessage(nextDayEvents[0]);

                            // Combine locations for the same day
                            const locations = nextDayEvents.map(e => `${e.locationName} (${e.locationCity})`).join(` ${translationsModal[lang].and} `);

                            // Sum up slots and determine the slot message
                            const totalSlots = nextDayEvents.reduce((sum, event) => sum + event.numberSlots, 0);
                            const slotsMessage = getAvailabilityMessage(totalSlots);

                            // Form the complete message
                            //const message = `<b>${dateMessage}</b> ${translationsModal[lang].messageCanFindUs} <b>${locations}</b>. ${slotsMessage}`;

                            // Set modal content
                            let prefix;
                            switch (city) {
                                case 'Lisboa':
                                    prefix = translationsModal[lang].prefixCity
                                    break;
                                case 'Porto':
                                    prefix = translationsModal[lang].prefixCityPorto
                                    break;
                                case 'Guimarães':
                                    prefix = translationsModal[lang].prefixCity
                                    break;
                                    default:
                                    prefix = translationsModal[lang].prefixCity
                              }

                            document.getElementById('nextCityTitle').innerText = `${translationsModal[lang].title} ${prefix} ${city}`;
                            document.getElementById('nextCityDate').innerText = dateMessage;
                            document.getElementById('nextCityPlaceName').innerText = locationName;
                            document.getElementById('nextCityPlaceRef').innerText = slotsMessage;
                            document.getElementById('nextCityCta').innerText = translationsModal[lang].book;
                            document.getElementById('nextCityCta').setAttribute("href", `${translationsModal[lang].bookLink}?date=${date}`);
                            // document.getElementById('nextCityMessage').innerHTML = message;

                            // Show the modal
                            const modal = document.getElementById('nextCity');
                            modal.style.display = "flex";
                            //setModalShown();
                        }
                    }
                }

        }


        displayModal();

        const modal = document.getElementById('availabilityModal');

        window.onclick = function(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        }
    });

})();